export enum TrsFeatureFlags {
  NcmHeader = 'ncm-header'
}